export default __webpack_public_path__ + "static/media/warning--stop-ahead--g1.19311854.png";